/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const EditFrameIcon = props => {
	const { color = '' } = props
	return (
		<svg
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			x={0}
			y={0}
			viewBox='0 0 19 19'
			style={{
				enableBackground: 'new 0 0 19 19'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
		>
			<style>{`.st0{fill: ${color}}`}</style>
			<g id='edit'>
				<path
					className='st0'
					d='M15.4 19H4.5c-1.3 0-2.3-1-2.3-2.3V5.9c0-1.3 1-2.3 2.3-2.3h5.4c.4 0 .8.3.8.8s-.3.8-.8.8H4.5c-.4 0-.8.4-.8.8v10.8c0 .4.4.8.8.8h10.8c.4 0 .8-.4.8-.8v-5.4c0-.4.3-.8.8-.8s.8.3.8.8v5.4c0 1.2-1.1 2.2-2.3 2.2z'
					transform='translate(-1.25 -.984)'
				/>
				<path
					className='st0'
					d='M7.6 14.4c-.2 0-.4-.1-.5-.2-.2-.2-.3-.5-.2-.7l.8-3.1c0-.1.1-.3.2-.3l7.4-7.4c1-.9 2.5-.9 3.4.1.9.9.9 2.4 0 3.3l-7.4 7.4c-.1.1-.2.2-.3.2l-3.1.8c-.2-.1-.2-.1-.3-.1zm1.5-3.5-.4 1.7 1.7-.4L17.5 5c.3-.3.3-.9 0-1.2-.3-.4-.9-.4-1.3 0l-7.1 7.1z'
					transform='translate(-1.25 -.984)'
				/>
			</g>
		</svg>
	)
}

export default EditFrameIcon
